import { Component, ErrorInfo, ReactNode } from 'react';
import { ErrorDisplay } from '@/common/components/error-display/ErrorDisplay';

interface ErrorBoundaryProps {
  children: ReactNode;
  className?: string;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('ErrorBoundary caught an error', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className={this.props.className}>
          <ErrorDisplay title="Something went wrong" message={this.state.error?.message} />
        </div>
      );
    }

    return this.props.children;
  }
}
